const {USER_STATUS_CONSTANTS} = require('../constants/AppConstants')
const {SEVERITY_LEVELS} = require('../constants/StatusConstants')

let utilities = {}

utilities.getStatusColor = (input) => {
  switch (input) {
    // gender colors
    case 'male':
      return '#e0f7fa'
    case 'female':
      return '#fce4ec'
    case 'N/A':
      return '#bdbde9'
    // status colors
    case USER_STATUS_CONSTANTS.active:
      return '#28a745'
    case USER_STATUS_CONSTANTS.inActive:
      return '#dc3545'
    case SEVERITY_LEVELS.CRITICAL:
      return 'red'
    case SEVERITY_LEVELS.WARNING:
      return '#ff6723'
    // BP readings
    case SEVERITY_LEVELS.LOW:
      return '#81D4FA'
    case SEVERITY_LEVELS.ELEVATED:
      return '#FFEB3B'
    case SEVERITY_LEVELS.HYPER_TENSION_STAGE_01:
      return '#FF9800'
    case SEVERITY_LEVELS.HYPER_TENSION_STAGE_02:
      return '#F44336'
    case SEVERITY_LEVELS.HYPERTENSIVE_CRISIS:
      return '#B71C1C'
    default:
      return 'yellow'
  }
}

utilities.getRequestedStatusColor = (input) => {
  // These are mainly used for the data tables

  switch (input) {
    case 0:
      return '#27c6cc'
    case 1:
      return '#2e821b'
    case 2:
      return '#9e000b'
    default:
      return 'blue'
  }
}

// Utility function to return the first letter of first and last name in capital letters.
utilities.getInitials = (firstName, lastName) => {
  if (!firstName || !lastName) return ''
  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
}

utilities.getSeverityColor = (input) => {
  switch (input) {
    // BP readings
    case '1':
      return '#81D4FA'
    case '2':
      return 'green'
    case '3':
      return '#eeca00'
    case '4':
      return '#FF9800'
    case '5':
      return '#F44336'
    case '6':
      return '#B71C1C'
    default:
      return 'blue'
  }
}

module.exports = utilities
